module.exports = __webpack_public_path__ + "static/media/FacebookLogo.228a978d.svg";